import { Element } from "@xmpp/xml"
import { Car, CarLastSeen } from "@/reducers/carsSlice"

export const CARS_NODE = "urn:slickshift:cars:0"

const isCarLastSeen = (value: string | undefined): value is CarLastSeen =>
  value === "recently" || value === "long_ago"

class CarsParser {
  static parseItem(item: Element): Car {
    const carElement = item.getChild("car", CARS_NODE)
    if (!carElement) {
      throw new Error("Car item missing car element")
    }

    const id = carElement.getAttr("id")
    const legacyId = carElement.getAttr("legacy_id")
    const label = carElement.getAttr("label")
    const plates = carElement.getAttr("plates")
    const lastSeen = carElement.getAttr("last_seen")
    const gpsBrand = carElement.getAttr("gps_brand")

    if (!id) {
      throw new Error("Car element missing required id attribute")
    }

    return {
      id,
      legacyId: legacyId || "",
      label: label || "",
      plates: plates || "",
      ...(isCarLastSeen(lastSeen) ? { lastSeen } : {}),
      ...(gpsBrand ? { gpsBrand } : {}),
    }
  }

  static parse(stanza: Element): Car | undefined {
    const eventNode =
      stanza.getChild("event", "http://jabber.org/protocol/pubsub#event") ||
      stanza.getChild("pubsub", "http://jabber.org/protocol/pubsub")
    if (!eventNode) return

    const itemsNode = eventNode.getChildByAttr("node", CARS_NODE)
    if (!itemsNode) return

    const itemNode = itemsNode.getChildren("item")[0]
    if (!itemNode) return

    return CarsParser.parseItem(itemNode)
  }
}

export default CarsParser
